/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createInvoiceDtoFromDiscriminatorValue, serializeInvoiceDto, serializeIssueInvoiceRequest, type ErrorResponse, type InternalErrorResponse, type InvoiceDto, type IssueInvoiceRequest } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/invoices/{invoiceId}/issue
 */
export interface IssueRequestBuilder extends BaseRequestBuilder<IssueRequestBuilder> {
    /**
     * Moves an invoice from Draft to Issued, marking it as sent to the customer and open for payment. Only a draft can be issued; an invoice in any other status — including one already issued — is refused, so this call is not idempotent. Issuing is the precondition for the payment endpoints, which reject a draft invoice. Once issued, an invoice can no longer be cancelled; void it instead.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<InvoiceDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: IssueInvoiceRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<InvoiceDto | undefined>;
    /**
     * Moves an invoice from Draft to Issued, marking it as sent to the customer and open for payment. Only a draft can be issued; an invoice in any other status — including one already issued — is refused, so this call is not idempotent. Issuing is the precondition for the payment endpoints, which reject a draft invoice. Once issued, an invoice can no longer be cancelled; void it instead.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: IssueInvoiceRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const IssueRequestBuilderUriTemplate = "{+baseurl}/api/invoices/{invoiceId}/issue";
/**
 * Metadata for all the requests in the request builder.
 */
export const IssueRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: IssueRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createInvoiceDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeIssueInvoiceRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
